<script>
export default {
    name: "accordion",
    props: ["question", "answer", "assets", "assettitles", "images"],
    data() {
        return {
            answer_visible: false
        };
    },
    methods: {
        toggle_answer() {
            this.answer_visible = !this.answer_visible;
        }
    },
    computed: {
        hasImages() {
            return this.images.length > 0;
        },
        hasAssets() {
            return this.assets.length > 0;
        },
        hasMoreThanOneAsset() {
            return this.assets.length > 1;
        }
    }
};
</script>

<template>
    <div class="bg-white border shadow rounded py-4 px-8 w-full mb-4" @click="toggle_answer">
        <p class="flex justify-between items-center leading-none" style="margin-bottom: 0;">
            <strong class="cursor text-2xl text-purple" v-html="question"></strong>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="w-4 h-4 fill-current mr-2 opacity-50" :class="answer_visible ? 'rotate-180' : 'rotate-0'"><path fill="currentColor" d="M443.5 162.6l-7.1-7.1c-4.7-4.7-12.3-4.7-17 0L224 351 28.5 155.5c-4.7-4.7-12.3-4.7-17 0l-7.1 7.1c-4.7 4.7-4.7 12.3 0 17l211 211.1c4.7 4.7 12.3 4.7 17 0l211-211.1c4.8-4.7 4.8-12.3.1-17z" class=""></path></svg>
        </p>
        <transition name="fade">
            <div
                v-if="answer_visible"
                class="clearfix content mt-4 font-normal text-lg"
                :class="hasImages ? 'flex -mx-3' : ''"
            >
                <div :class="{ 'w-2/3 px-3' : hasImages  }">
                    <span v-html="answer" class="cursor"></span>
                    <a
                        v-if="hasMoreThanOneAsset"
                        v-for="(asset, key) in assets"
                        :href="asset"
                        class="button"
                        target="_blank"
                        v-html="assettitles[key]"
                        :key="key"
                    ></a>
                    <a
                        v-else-if="hasAssets"
                        :href="assets[0]"
                        class="button"
                        target="_blank"
                        v-html="assettitles[0]"
                    ></a>
                </div>
                <div v-if="hasImages" class="w-1/3 px-3">
                    <img v-for="(image, key) in images" :src="image" :key="key">
                </div>
            </div>
        </transition>
    </div>
</template>
